var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barchart-drilldown-wrapper"},[(_vm.chart_config)?_c('dynamic-chart-component',{attrs:{"el":"barchart-tes-001","config":_vm.chart_config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }